import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";


// All Quotes ( First Page )

const getQuotesSummary = async (clientCode) => {
  const res = await apiClient(
    `/api/v9/myBinnys/getAllQuotes?clientCode=${clientCode}`
  );
  return res.data?.data || [];
};

export const useQuotes = (clientCode) => {
  return useQuery({
    queryKey: ["quotesSummary", clientCode],
    queryFn: () => getQuotesSummary(clientCode),
    enabled: !!clientCode,
  });
};


// All Quotes Summary 

export const fetchQuotesSummary = async ({ queryKey }) => {
    const [_key, { clientId, status }] = queryKey;
  
    const body = {
      clientCode: clientId,
      quotesStatus: status,
      search: ""
    };
  
    const res = await apiClient.post(
      "/api/v9/myBinnys/getAllQuotesSummary",
      body
    );
  
    return res.data?.data ?? { data: [], totalCount: 0 };
  };
  

// All Quotes Designs... 

export const getAllQuotesDesign = async ({ queryKey }) => {
  const [, payload] = queryKey;

  const res = await apiClient.post(
    "/api/v9/myBinnys/getAllQuotesDesign",
    payload
  );

  return res.data?.data?.orderData;
};
